/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { AfterViewInit, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoadingPanelService } from '../../shared/loading-panel/loading-panel.service';
import { ToastService, ToastType } from '../../shared/toast/toast.service';
import { CurrentUserService } from '../../user/services';
import { PartnerIdentificationTypeService } from '../../partner/services/partner-identification-type.service';
import { DistributionObjectGroup } from '../models/document-type-group';
import { DocumentTypeDeveloper, IdentificationType, LightTrackingOptions } from '../models/document-type';
import { DeveloperService } from '../services/developer.service';
import { GridService } from '../../shared/grid/grid.service';
import { SvgIconComponent } from '../../shared/icons/svg-icon.component';
import { PermissionRequiredDirective } from '../../shared/authentication/permission-required.directive';
import { ChangeLogLinkComponent } from '../../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../../shared/change-log/change-log-link-entity/change-log-link-entity.directive';
import { DxDataGridModule, DxCheckBoxModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../../shared/grid/biz-grid.directive';
import { DxoEditingModule, DxoPopupModule, DxoFormModule, DxiItemModule, DxoLabelModule, DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, DxoLookupModule, DxiButtonModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { BizUserColumnDirective } from '../../shared/grid/biz-grid-user.directive';
import { BizDateColumnDirective } from '../../shared/grid/biz-grid-date.directive';
import { DeveloperArtifactXmlPickerComponent } from '../developer-artifacts/developer-artifact-xml-picker.component';
import { BizGridFiltervalues } from 'src/app/shared/grid/biz-grid-filtervalues';
import { ColumnEditCellTemplateData } from 'devextreme/ui/data_grid';
import { XPathComponent } from 'src/app/controls/components/advanced/xpath/xpath.component';

@Component({
    selector: 'app-developer-document-types',
    templateUrl: './developer-document-types.component.html',
    styleUrls: ['./developer-document-types.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, PermissionRequiredDirective, ChangeLogLinkComponent, ChangeLogLinkEntityDirective, DxDataGridModule, BizDataGridDirective, DxoEditingModule, DxoPopupModule, DxoFormModule, DxiItemModule, DxoLabelModule, DxTemplateModule, DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, DxoLookupModule, BizUserColumnDirective, BizDateColumnDirective, DxiButtonModule, DxCheckBoxModule, DeveloperArtifactXmlPickerComponent, XPathComponent]
})
export class DeveloperDocumentTypesComponent implements OnInit, AfterViewInit {
    documentTypes: DocumentTypeDeveloper[] = [];
    documentTypeGroups: DistributionObjectGroup[] = [];
    identificationTypes: IdentificationType[] = [];
    allowAdding = false;
    allowUpdating = false;
    allowDeleting = false;
    allowAddingQualifier = false;
    allowUpdatingQualifier = false;
    allowDeletingQualifier = false;
    allowShowLog = false;
    dropDownOptions = { width: 500 };

    labelTemplates = [
        {
            name: 'messageIn',
            icon: 'dx-icon-help',
            title: 'This file is necessary to enable the "Resend by document" feature in document tracking\nThe "Resend by interchange" feature is not affected'
        },
    ];

    constructor(
        private developerService: DeveloperService,
        private loadingPanelService: LoadingPanelService,
        private toastService: ToastService,
        private currentUserService: CurrentUserService,
        private partnerIdentificationTypeService: PartnerIdentificationTypeService,
        private gridService: GridService,
        public bizGridFiltervalues: BizGridFiltervalues) {
    }

    ngOnInit(): void {
        this.allowAdding = this.currentUserService.hasPermission('Developer_Action_DocumentType_Create');
        this.allowUpdating = this.currentUserService.hasPermission('Developer_Action_DocumentType_Edit');
        this.allowDeleting = this.currentUserService.hasPermission('Developer_Action_DocumentType_Delete');
        this.allowShowLog = this.currentUserService.hasPermission('Developer_Action_ShowLog');

        this.allowAddingQualifier = this.currentUserService.hasPermission('Developer_Action_IdentificationTypeQualifier_Create');
        this.allowUpdatingQualifier = this.currentUserService.hasPermission('Developer_Action_IdentificationTypeQualifier_Edit');
        this.allowDeletingQualifier = this.currentUserService.hasPermission('Developer_Action_IdentificationTypeQualifier_Delete');
    }

    onEditorPreparing(e) {
        if (e.dataField === 'Description' && e.parentType === 'dataRow') {
            e.editorName = 'dxTextArea';
        }
    }

    ngAfterViewInit(): void {
        void this.refresh();
    }

    async refresh(): Promise<void> {
        try {
            this.loadingPanelService.showLoadingPanelDirect('Loading...');

            [
                this.identificationTypes,
                this.documentTypeGroups,
                this.documentTypes
            ] = await Promise.all([
                this.partnerIdentificationTypeService.getIdentificationTypes(true),
                this.developerService.getDistributionObjectGroups(),
                this.developerService.getDocumentTypes(),
            ]);
            this.documentTypeGroups.sort((a, b) => a.Name.localeCompare(b.Name));
        }
        catch (err) {
            console.error(err);
            this.toastService.showToast('Failed to load data...', ToastType.error);
        }
        finally {
            this.loadingPanelService.hideLoadingPanel();
        }
    }

    getFileNameForGuid(cellInfo: any): Promise<string> {
        return cellInfo.filename;
    }

    onInitNewRow(e: any): void {
        e.data = {
            Id: 0,
            Name: '',
            CdmStylesheetArtifactId: null,
            UsableForDistributions: true,
            Description: '',
            DocumentTypeGroupId: null,
            CdmEmbeddedFileDataXPath: null,
            CdmEmbeddedFileNameXPath: null,
            LightTrackingOptions: new LightTrackingOptions(),
            FilenamingTypes: [],
            CreatedDate: new Date(),
            CreatedBy: -1,
            UpdatedDate: null,
            UpdatedBy: null,
        } as DocumentTypeDeveloper;
    }

    onRowInserting = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data as DocumentTypeDeveloper, item => this.saveDocumentType(item));
    };

    onRowUpdating = (e: any): void => {
        const input: DocumentTypeDeveloper = {
            ...e.key,
            ...e.newData,
            LightTrackingOptions: new LightTrackingOptions({
                ...e.key.LightTrackingOptions,
                ...e.newData.LightTrackingOptions
            })
        };
        e.cancel = this.gridService.handleDataGridRow(input, item => this.saveDocumentType(item), e.newData);
    };

    onRowRemoving = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data as DocumentTypeDeveloper, item => this.removeDocumentType(item));
    };

    async saveDocumentType(documentType: DocumentTypeDeveloper): Promise<DocumentTypeDeveloper> {
        if (this.documentTypes.find(i => i.Name === documentType.Name && i.Id !== documentType.Id)) {
            throw new Error('Another document type with that name already exists.');
        }

        // Context properties are removed from the UI and are set to the same value as the MessageIn properties
        documentType.LightTrackingOptions.TrackMessageContext = documentType.LightTrackingOptions.TrackMessageIn;

        const newItem = await this.developerService.saveDocumentType(documentType);
        this.toastService.showToast('Document type saved...', ToastType.success);
        return newItem;
    }

    async removeDocumentType(documentType: DocumentTypeDeveloper): Promise<DocumentTypeDeveloper> {
        const allowDeleting = await this.developerService.allowDeleteDocumentType(documentType.Id);
        if (!allowDeleting) {
            throw new Error('It is not possible to delete the document type, because it is currently in use.');
        }

        await this.developerService.deleteDocumentType(documentType.Id);
        this.toastService.showToast('Document type deleted...', ToastType.success);
        return documentType;
    }

    setArtifactId(artifactId, cellInfo: any) {
        cellInfo.setValue(artifactId || null);
    }

    // For use with grid in drop down template
    onSelectionChanged(selectedRowKeys, cellInfo, dropDownBoxComponent): void {
        cellInfo.setValue(selectedRowKeys[0]);
        if (selectedRowKeys.length > 0) {
            dropDownBoxComponent.close();
        }
    }

    onXPathValueChange($event: string, cell: ColumnEditCellTemplateData<DocumentTypeDeveloper, unknown>) {
        if (cell.value !== $event) {
            cell.setValue($event);
        }
    }
}
